import React from 'react';

import style from './editUserModal.module.css';
import userStyle from '../userManagement.module.css';
import commonStyles from '../../../common/common.module.css';

import { TextField, Button, Grid, withStyles, createStyles, Theme, Select, InputLabel, FormControl, DialogTitle, IconButton, Dialog, DialogContent, OutlinedInput } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { UserRoleType } from '../../../../models/User';

import roles from '../../../../configs/roles';

interface EditUserModalProps {
  type: 'reactivate' | 'update' | 'create';
  firstName: string;
  lastName: string;
  userType: UserRoleType.FORWARDER | UserRoleType.GHA;
  role: string;
  email: string;
  modalOpen: boolean;
  handleClose: () => void;
  handleChange: (e: any) => void;
  editUser: () => void;
  classes: any;
};

const styles = (theme: Theme) =>

  createStyles({
    formField: {
      height: 'auto',
      width: '100%',
      marginTop: '0 !important',
      '& select':{
        padding: '7px 12px'
      }
    },
  });

const EditUserModal = (props: EditUserModalProps) => {
  let headerText = 'Reactivate user';
  if (props.type === 'update') {
    headerText = 'Edit user';
  }
  if (props.type === 'create') {
    headerText = 'Create user';
  }

  let userRoles: Array<{ code: string, name: string }>;
  if (props.userType === UserRoleType.FORWARDER) {
    userRoles = roles.forwarderRoles;
  } else {
    userRoles = roles.ghaRoles;
  }

  return (
    <Dialog
      open={props.modalOpen}
      onClose={props.handleClose}
      aria-labelledby="form-dialog-title"
      maxWidth={'sm'}
      fullWidth={true}
    >
      <DialogTitle id="form-dialog-title" >
        <div className={style.dialogTitle}>
          <span className={style.name}>{headerText}</span>
          <IconButton aria-label="Close" className={style.close} onClick={props.handleClose}>
            <CloseIcon color='primary' />
          </IconButton>
        </div>
        <hr />
      </DialogTitle>
      <DialogContent>
        <div className={ commonStyles.wrapper }>
          <Grid container className={props.classes.rowContainer}>
            <Grid item  sm={6} xs={12} className={ `${ style.gridItem } ${ commonStyles.inputLabelWrapper }` }>
              <label className={ commonStyles.inputLabel }> Last name </label>
              <TextField
                id="lastName"
                label=""
                name="lastName"
                fullWidth={true}
                onChange={props.handleChange}
                className={props.classes.formField}
                InputProps={{className: props.classes.formField}}
                InputLabelProps={{
                  shrink: true
                }}
                value={props.lastName}
                variant="outlined"
              />
            </Grid>
            <Grid item sm={6} xs={12} className={ `${ style.gridItem } ${ commonStyles.inputLabelWrapper }` }>
              <label className={ commonStyles.inputLabel }> First name </label>
              <TextField
                id="firstName"
                label=""
                name="firstName"
                fullWidth={true}
                onChange={props.handleChange}
                className={props.classes.formField}
                InputProps={{className: props.classes.formField}}
                InputLabelProps={{
                  shrink: true
                }}
                value={props.firstName}
                variant="outlined"
              />
            </Grid>
            <Grid item sm={6} xs={12} className={ `${ style.gridItem } ${ commonStyles.inputLabelWrapper }` }>
              <label className={ commonStyles.inputLabel }> Email/username </label>
              <TextField
                id="email"
                label=""
                name="email"
                fullWidth={true}
                onChange={props.handleChange}
                className={ props.classes.formField }
                InputProps={{className: props.classes.formField}}
                InputLabelProps={{
                  shrink: true
                }}
                value={props.email}
                variant="outlined"
              />
            </Grid>
            <Grid item sm={6} xs={12} className={ `${ style.gridItem } ${ commonStyles.inputLabelWrapper }` }>
              <FormControl className={props.classes.formField}>
                <label className={ commonStyles.inputLabel } id="role"> User role </label>
                <Select
                  native
                  id="role"
                  name="role"
                  onChange={props.handleChange}
                  className={props.classes.formField}
                  value={props.role}
                >
                  <option value=''/>
                  { userRoles.map(role => {
                      return (<option value={ role.code } key={ role.code }>{ role.name }</option>);
                    })
                  }
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </div>
        <div className={ `${ userStyle.buttonContainer } ${ commonStyles.fSpaceBtw }` } >
          <Button
            color="primary"
            variant="contained"
            onClick={props.handleClose}
          >Close</Button>
          <Button
            color="primary"
            variant="contained"
            onClick={props.editUser}
          >Update</Button>
        </div>
      </DialogContent>
    </Dialog>
  )
};

export default withStyles(styles)(EditUserModal);;
